module.exports = __webpack_public_path__ + "media/images/countryrect/dm-6b2a13546a98d8a34077168aab5f60a2.svg";